export default {
  name: 'test-result-question-option',
  props: {
    item: {}
  }
}
